export default {
  "orderList.thead.merOrderno": "MerOrderno",
  "orderList.thead.orderno": "Orderno",
  "orderList.thead.phone": "Phone",
  "orderList.thead.payAmount": "PayAmount",
  "orderList.thead.rechargeAmount": "RechargeAmount",
  "orderList.thead.claimAmount": "ClaimAmount",
  "orderList.thead.sentAmount": "SentAmount",
  "orderList.thead.channel": "Channel",
  "orderList.thead.statusDesc": "StatusDesc",
  "orderList.thead.createTime": "CreateTime",
  "orderList.thead.startTime": "StartTime",
  "orderList.thead.endTime": "EndTime",
  "orderList.status-code.notStart": "Not Start",
  "orderList.status-code.expired": "Expired",
  "orderList.status-code.claimReward": "Claim Reward",
  "orderList.thead.option": "Options",
};
